import { EQuestionActionsTypes } from '@cian/frontend-request-form-widget';
import { EFormFieldsNames, EQuestionCodes, EStepCodes } from '../../../types/requestForm';
import { createFields } from './utils/createFields';
import { createValidation } from './utils/createValidation';
import { createField } from './utils/createField';
import { formatBytes } from '../../../utils/formatBytes';
import { SEND_FEEDBACK_BUTTON_TEXT } from '../../../constants/requestForm/buttonText';
export var FILES_COUNT_LIMIT = 10;
export var FILE_SIZE_LIMIT = 10 * 1024 * 1024; // 10 мегабайт

var FIELDS = [EFormFieldsNames.Name, EFormFieldsNames.Phone, EFormFieldsNames.Email, EFormFieldsNames.DuplicateOfferLink,
// Здесь мы используем хелпер createField и видоизменяем его конфигурацию,
// так как хотим использовать состояние поля message.
createField(EFormFieldsNames.Message, {
  label: 'Расскажите, почему нужно удалить объявление',
  description: ''
}), EFormFieldsNames.OwnerOfferLink,
// Здесь мы используем хелпер createField и видоизменяем его базовую конфигурацию,
// так как хотим использовать состояние поля files.
createField(EFormFieldsNames.Files, {
  description: "\n      \u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0438\u0442\u0435 \u043E\u0440\u0438\u0433\u0438\u043D\u0430\u043B\u044B \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0439:\n      \u0434\u043E ".concat(FILES_COUNT_LIMIT, " \u0444\u0430\u0439\u043B\u043E\u0432 \u043F\u043E ").concat(formatBytes(FILE_SIZE_LIMIT), " \u043A\u0430\u0436\u0434\u044B\u0439\n    "),
  fileUploader: {
    filesCountLimit: FILES_COUNT_LIMIT,
    fileSizeLimit: FILE_SIZE_LIMIT
  },
  required: true
}), EFormFieldsNames.PrivacyPolicyAccepted];
export var COMPLAINT_FROM_OWNER_PHOTO_STEP = {
  code: EStepCodes.ComplaintFromOwnerPhoto,
  question: {
    code: EQuestionCodes.ComplaintFromOwnerPhoto,
    title: 'Жалоба от собственника фотографий',
    fields: createFields(FIELDS),
    validation: createValidation(FIELDS),
    actions: [{
      type: EQuestionActionsTypes.NextQ,
      text: SEND_FEEDBACK_BUTTON_TEXT
    }]
  },
  nextStep: [{
    conditions: [],
    nextStepCode: null
  }]
};